import React, { useEffect, useState } from "react";
import { ReactSearchAutocomplete } from 'react-search-autocomplete'
import { getAllPatients } from "../../../Utils/localStore";




const PatientSearch = ({ className, SelectedPatient }) => {
    const [patients, setPatients] = useState([])
    const getLocalData = async () => {

        await getAllPatients()
            .then(resp => {
                setPatients(resp)
            })
    }
    useEffect(() => {
        getLocalData()
    }, [])

    const items = [
        {
            id: 0,
            name: 'Cobol'
        },
        {
            id: 1,
            name: 'JavaScript'
        },
        {
            id: 2,
            name: 'Basic'
        },
        {
            id: 3,
            name: 'PHP'
        },
        {
            id: 4,
            name: 'Java'
        }
    ]

    const handleOnSearch = (string, results) => {
        // onSearch will have as the first callback parameter
        // the string searched and for the second the results.
        // console.log(string, results, 'onserch')
    }

    const handleOnHover = (result) => {
        // the item hovered
        // console.log(result)
    }

    const handleOnSelect = (item) => {
        // the item selected
        SelectedPatient(item)
        // console.log(item)
    }

    const handleOnFocus = () => {
        // console.log('Focused')
    }
    const formatResult = (item) => {
        return (
            <>
                {/* <span style={{ display: 'block', textAlign: 'left' }}>id: {item.localID}</span> */}

                <span className="p-4 capitalize cursor-pointer" style={{ display: 'block', textAlign: 'left' }}>{item.patientName}</span>
            </>
        )
    }
    return (
        <ReactSearchAutocomplete className={className}
            items={patients}
            onSearch={handleOnSearch}
            onHover={handleOnHover}
            onSelect={handleOnSelect}
            onFocus={handleOnFocus}
            autoFocus
            fuseOptions={{ keys: ["patientName"] }}
            resultStringKeyName='patientName'
            placeholder="Enter Patients name"
            formatResult={formatResult} />
    )
}

export default PatientSearch